import React from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import Radio, { RadioProps } from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "var(--dmg-bg)",
    // "input:hover ~ &": {
    //   backgroundColor: "transparent",
    // },
    "input:disabled ~ &": {
      boxShadow:
        "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    },
  },
  checkedIcon: {
    backgroundColor: "var(--dmg-purple)",
    boxShadow: "none",
    backgroundImage: "",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(var(--dmg-bg),var(--dmg-bg) 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      opacity: 0.9,
    },
  },
});

// Inspired by blueprintjs
function StyledRadio(props: RadioProps) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

interface CustomizedRadio {
  value?: string;
  label?: string;
  checked?: boolean;
  disabled?: boolean;
}

export default function CustomizedRadio(props: CustomizedRadio) {
  const { value, label, checked, disabled } = props;
  return (
    <FormControlLabel
      value={value}
      control={<StyledRadio />}
      label={label}
      checked={checked}
      disabled={disabled}
    />
  );
}
